import {
    SET_FUEL_TYPE,
} from "./FuelTypeTypes";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_FUEL_TYPE:
            return {
                ...state,
                fuelTypeDropDown: action.fuelTypeList,
            };
        default:
            return state;
    }
};

export default reducer;